import AgethIcon from "@/icons/token/ageth-icon";
import AmphrlrtIcon from "@/icons/token/amphrlrt-icon";
import EbtcIcon from "@/icons/token/ebtc-icon";
import LbtcIcon from "@/icons/token/lbtc-icon";
import PufethIcon from "@/icons/token/pufeth-icon";
import PzethIcon from "@/icons/token/pzeth-icon";
import RethIcon from "@/icons/token/reth-icon";
import RsethIcon from "@/icons/token/rseth-icon";
import UnibtcIcon from "@/icons/token/unibtc-icon";
import UniethIcon from "@/icons/token/unieth-icon";
import WeethsIcon from "@/icons/token/weeths-icon";
import WstethIcon from "@/icons/token/wsteth-icon";

import ArbitrumIcon from "../../../icons/token/arbitrum-icon";
import BlastIcon from "../../../icons/token/blast-icon";
import EthIcon from "../../../icons/token/eth-icon";
import EthPlusIcon from "../../../icons/token/ethplus-icon";
import EusdIcon from "../../../icons/token/eusd-icon";
import GmxIcon from "../../../icons/token/gmx-icon";
import KnoxIcon from "../../../icons/token/knox-icon";
import MusdIcon from "../../../icons/token/musd-icon";
import PendleIcon from "../../../icons/token/pendle-icon";
import PtWethIcon from "../../../icons/token/pt-weeth-icon";
import RadiantIcon from "../../../icons/token/radiant-icon";
import UsdbIcon from "../../../icons/token/usdb-icon";
import UsdcIcon from "../../../icons/token/usdc-icon";
import UsdeIcon from "../../../icons/token/usde-icon";
import Usdt from "../../../icons/token/usdt";
import WbtcIcon from "../../../icons/token/wbtc-icon";

export const TOKEN_ICONS = {
  ETH: EthIcon,
  WETH: EthIcon,
  ARB: ArbitrumIcon,
  USDC: UsdcIcon,
  "USDC.e": UsdcIcon,
  GMX: GmxIcon,
  BLAST: BlastIcon,
  "ETH+": EthPlusIcon,
  eUSD: EusdIcon,
  KNOX: KnoxIcon,
  ezETH: EthIcon,
  weETH: PtWethIcon,
  USDe: UsdeIcon,
  sUSDe: UsdeIcon,
  USDT: Usdt,
  WBTC: WbtcIcon,
  PENDLE: PendleIcon,
  MUSD: MusdIcon,
  RDNT: RadiantIcon,
  USDB: UsdbIcon,
  pzETH: PzethIcon,
  uniETH: UniethIcon,
  amphrETH: EthIcon,
  rsETH: RsethIcon,
  agETH: AgethIcon,
  amphrLRT: AmphrlrtIcon,
  "PT-weETH-27JUN2024": PtWethIcon,
  "PT-ezETH-26DEC2024": EthIcon,
  "PT-USDe-29AUG2024": UsdeIcon,
  "PT-weETH-26SEP2024": PtWethIcon,
  "PT-USDe-25JUL2024": UsdeIcon,
  "PT-ezETH-26SEP2024": EthIcon,
  "PT-weETH-26DEC2024": PtWethIcon,
  "PT-uniETH-26SEP2024": UniethIcon,
  "PT-amphrETH-26SEP2024": EthIcon,
  "PT-pzETH-26SEP2024": PzethIcon,
  "PT-rsETH-26SEP2024": RsethIcon,
  "PT-agETH-26DEC2024": AgethIcon,
  "PT-rsETH-26DEC2024": RsethIcon,
  "PT-amphrLRT-26SEP2024": AmphrlrtIcon,
  "PT-amphrLRT-26DEC2024": AmphrlrtIcon,
  pufETH: PufethIcon,
  "PT-pufETH-26DEC2024": PufethIcon,
  uniBTC: UnibtcIcon,
  "PT-EBTC-26DEC2024": EbtcIcon,
  eBTC: EbtcIcon,
  "PT-weETHs-26DEC2024": WeethsIcon,
  weETHs: WeethsIcon,
  "PT-amphrETH-26DEC2024": EthIcon,
  "PT-Re7LRT-26DEC2024": EthIcon,
  Re7LRT: EthIcon,
  "PT-uniETH-26DEC2024": UniethIcon,
  "PT-cornLBTC-26DEC2024": LbtcIcon,
  LBTC: LbtcIcon,
  "PT-USDe-28NOV2024": UsdeIcon,
  "PT-gUSDC-6DEC2024": UsdcIcon,
  USDE: UsdeIcon,
  "PT-corn-uniBTC-26DEC2024": UnibtcIcon,
  "PT-corn-pumpBTC-26DEC2024": WbtcIcon,
  "PT-gUSDC-26DEC2024": UsdcIcon,
  "PT-LBTC-27MAR2025": LbtcIcon,
  "PT-rsETH-26JUN2025": RsethIcon,
  "PT-wstETH-26JUN2025": WstethIcon,
  "PT-uniETH-26JUN2025": UniethIcon,
  "PT-weETH-26JUN2025": PtWethIcon,
  "PT-rETH-26JUN2025": RethIcon,
  "PT-corn-eBTC-27MAR2025": EbtcIcon,
};

export type AvailableTokens = keyof typeof TOKEN_ICONS;
